// extracted by mini-css-extract-plugin
export var contentBody = "_8w-9";
export var headerImage = "_8w-2";
export var imageButton = "_8w-7";
export var imageButtonIcon = "_8w-8";
export var imageHeader = "_8w-4";
export var imageHeaderText = "_8w-5";
export var imageOverlay = "_8w-3";
export var imageTitle = "_8w-6";
export var imageWrapper = "_8w-1";
export var taskList = "_8w-a";
export var widget = "_8w-0";